import { render, staticRenderFns } from "./ContentDetailWrapper.vue?vue&type=template&id=7fc50542&"
import script from "./ContentDetailWrapper.vue?vue&type=script&lang=js&"
export * from "./ContentDetailWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports